//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, createNamespacedHelpers, mapGetters } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import { ACTION_LOG_IN } from '@/scripts/store/actions/pdp'
import { ACTION_LOAD_USER } from '@/scripts/store/actions'
const RbLoading = () =>
  import(/* webpackChunkName: "loader-chunk" */ '@/elements/loading/rb-loading.vue')

const { mapActions: mapActionsPdp } = createNamespacedHelpers('pdp')

import { WcsLogin } from '@/scripts/libs/wcs/login'
export default {
  name: 'rb-forgot-password',
  components: {
    RbLoading,
  },
  data: function () {
    return {
      emailAddress: '',
      submitted: false,
      response: false,
      error: false,
      errorMessage: false,
      success: false,
    }
  },
  validations: {
    emailAddress: {
      required,
      email,
    },
  },
  computed: {
    ...mapGetters(['translation']),
  },
  methods: {
    ...mapActions({
      loadUserData: ACTION_LOAD_USER,
    }),
    ...mapActionsPdp({
      logIn: ACTION_LOG_IN,
    }),
    handleClose() {
      this.password = ''
      this.emailAddress = ''
      this.submitted = false
      this.response = false
      this.$emit('close')
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.submitted = true
        WcsLogin.submitForgotPasswordForm({
          logonEmail: this.emailAddress,
        }).then((response) => {
          if (response.error) {
            this.error = response.error
            this.errorMessage = response.errorMessage
            this.submitted = false
          } else {
            this.submitted = false
            this.success = true
          }
        })
      }
    },
  },
}
